import React, { forwardRef, useEffect, useState } from 'react';
import { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';
import type { FormValues, FormError, FormViewerHandle } from '@wix/form-viewer/widget';
import { FormViewer } from '@wix/form-viewer/widget';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { FormControllerStatus } from '../../types';
import { classes } from './AdditionalDetails.st.css';
import { AdditionalDetailsLoader } from './AdditionalDetailsLoader';

const AdditionalDetails = forwardRef<
  FormViewerHandle,
  {
    plan: Plan;
    formValues: FormValues;
    setFormValues: (values: FormValues) => void;
    formControllerStatus: FormControllerStatus;
    onLoad?: () => void;
  }
>(({ plan, formValues, setFormValues, formControllerStatus, onLoad }, ref) => {
  const { i18n } = useTranslation();
  const [formErrors, setFormErrors] = useState<FormError[]>([]);

  useEffect(() => {
    onLoad?.();
  }, [onLoad]);

  if (formControllerStatus === 'LOADING') {
    return <AdditionalDetailsLoader />;
  }

  if (formControllerStatus === 'ERROR') {
    // TODO: Add error state
    return null;
  }

  return (
    <div className={classes.root}>
      <FormViewer
        ref={ref}
        i18n={i18n}
        onChange={(values) => setFormValues(values)}
        values={formValues}
        onValidate={(errors) => setFormErrors(errors)}
        errors={formErrors}
        formId={plan.formId!}
      />
    </div>
  );
});

export default AdditionalDetails;
